<template>
  <div class="ws-spec">
    <div v-for="(item, itemIndex) in value" :key="itemIndex" class="ws-spec__item">
      <div>
        <ContentChip
          v-for="(chip, chipKey) in item.chips"
          :key="chipKey"
          :color="chip.color"
          :leadingIcon="chip.leadingIcon"
          :yellow="chip.color === 'yellow'"
          :orange="chip.color === 'orange'"
          :light-gray="chip.color === 'gray'"
          :text-label="$_getLocale(chip, 'name')"
          class="mr-8"
        />
        <LvText
          noWrap
          :h6="titleFontSize === 'h6'"
          :h5="titleFontSize === 'h5'"
          :h4="titleFontSize === 'h4'"
          :h3="titleFontSize === 'h3'"
          :h2="titleFontSize === 'h2'"
          :h1="titleFontSize === 'h1'"
          :remark="titleFontSize === 'remark'"
          :class="{ 'mt-8': item.chips && item.chips.length > 0 }"
        >
          {{ $t(item.title) }}
        </LvText>
      </div>
      <LvText
        wrap
        lightGray
        :h6="textFontSize === 'h6'"
        :h5="textFontSize === 'h5'"
        :h4="textFontSize === 'h4'"
        :h3="textFontSize === 'h3'"
        :h2="textFontSize === 'h2'"
        :h1="textFontSize === 'h1'"
        :remark="textFontSize === 'remark'"
        class="ws-spec__item-text"
      >
        {{ $_getText(item.text) }}
        <i
          v-if="item.icon"
          class="ws-spec__item-icon"
          :class="item.icon"
          @click.stop="$_onClickIcon(item)"
        />
      </LvText>
    </div>
  </div>
</template>
<script>
import H_common from '@/helpers/common';

export default {
  name: 'WsSpec001',
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    titleFontSize: {
      type: String,
      default: 'h6',
    },
    textFontSize: {
      type: String,
      default: 'h6',
    },
  },
  methods: {
    $_getText(rawText) {
      return rawText === 0 ? 0 : this.$t(rawText);
    },
    $_onClickIcon(item) {
      this.$emit(item.iconEvent ? item.iconEvent : 'click-icon', item);
    },
    $_getLocale(object, textKey) {
      return H_common.getLocale(object, textKey);
    },
  },
};
</script>
